import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Video",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("iframe", {
        src: _ctx.media.url,
        width: "100%",
        height: "400",
        frameborder: "0",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: ""
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 512))
}